import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchTrialBalanceData = createAsyncThunk(
    'user/fetchTrialBalanceData',
    async (userId) => {
        try{
        
            const response = await fetchFun(`/api/v1/trialBalance/qbData?userId=${userId}`);
            if(response.success){
                return response?.data;
            }
        } catch (error) {
            console.log("Error - /trialBalance/qbData", error)
        }
    }
);